/**
 * 文件描述：封装直播录制文件查询与回放管理接口
 * @author DIY
 * @createTime 2026-07-23
 */
import request from '@/config/axios'

/** 录制文件分页查询条件 */
export interface LiveRecordingPageParams {
  pageNo: number
  pageSize: number
  liveId?: number
  status?: number
  startTime?: string[]
}

/** 录制文件信息 */
export interface LiveRecording {
  id: number
  liveId: number
  providerRecordId?: string
  fileId?: string
  fileUrl?: string
  coverUrl?: string
  duration?: number
  fileSize?: number
  format?: string
  definition?: string
  status: number
  auditStatus: number
  primary: boolean
  startTime?: string
  endTime?: string
  createTime?: string
}

const RECORDING_PAGE_URL = '/live/recording/page'
const RECORDING_SET_PRIMARY_URL = '/live/recording/set-primary'
const RECORDING_DISABLE_URL = '/live/recording/disable'

/** 分页查询录制文件 */
export const getRecordingPage = (params: LiveRecordingPageParams) =>
  request.get({ url: RECORDING_PAGE_URL, params })

/** 设置主回放 */
export const setPrimaryRecording = (id: number) =>
  request.post({ url: RECORDING_SET_PRIMARY_URL, params: { id } })

/** 禁用回放文件 */
export const disableRecording = (id: number) =>
  request.post({ url: RECORDING_DISABLE_URL, params: { id } })
